import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ResumeUploadForm from './components/resume-upload/ResumeUploadForm';
import CandidateDashboard from './components/Dashboard/CandidateDashboard';
import ConductInterview from './components/Interview/ConductInterview';
import IndividualCandidateDashboard from './components/IndividualCandidateDashboard/IndividualCandidateDashboard';
import AdminLogin from './components/Login/AdminLogin';
import JobListings from './components/CandidateResumeUpload/JobListings';
import JobApplicationForm from './components/CandidateResumeUpload/JobApplicationForm';
import ApplicationSuccess from './components/CandidateResumeUpload/ApplicationSuccess';
import JobCreator from './components/resume-upload/JobCreator';

// Create QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2, // Retry failed requests 2 times
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/" element={<ResumeUploadForm />} />
          <Route path="/dashboard" element={<CandidateDashboard />} />
          <Route path="/interview/:sessionId" element={<ConductInterview />} />
          <Route path="/candidate/:candidateId/dashboard" element={<IndividualCandidateDashboard />} />
          <Route path="/apply/:jobId" element={<JobApplicationForm />} />
          <Route path="/jobs" element={<JobListings />} />
          <Route path="/success" element={<ApplicationSuccess />} />
          <Route path="/create-job" element={<JobCreator />} />
          
          
          {/* Add more routes as needed */}
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;